import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PensionContext, PensionParameters } from '../../../contexts/pension-robot/PensionContext';
import { CurrencyFormGroup } from '../../general/form-inputs/CurrencyFormGroup';
import { CocktailWrapperScreen } from './CocktailWrapperScreen';
import { SavingButtons } from './DialogueDataSaver';
import { BackButton, NextButton } from './NavigationButtons';

export const PensionGrossSection: React.FC<{ isPartnerSection?: boolean }> = ({ isPartnerSection = false }) => {
    const { t } = useTranslation('pension');
    const {
        parameters: { pensionInfo, personalInfo },
        actions,
    } = useContext(PensionContext);

    return (
        <CocktailWrapperScreen
            page={3}
            title={
                isPartnerSection
                    ? t('pension-cocktail-fill-screen-gross-title-partner')
                    : t('pension-cocktail-fill-screen-gross-title')
            }
            subTitle={
                isPartnerSection
                    ? t('pension-cocktail-fill-screen-gross-subtitle-partner')
                    : t('pension-cocktail-fill-screen-gross-subtitle')}
        >
            {!isPartnerSection && (
                <CurrencyFormGroup
                    title={{
                        label: t('pension-cocktail-fill-screen-gross-label'),
                        tooltip: { title: 'TODO', text: 'TODO' },
                    }}
                    value={pensionInfo?.self?.employeePensionGrossYearly}
                    onChange={(cents) => {
                        actions.setParameters({
                            pensionInfo: { self: { employeePensionGrossYearly: cents } },
                        });
                    }}
                    className="mb-8"
                />
            )}
            {!!isPartnerSection && (
                <CurrencyFormGroup
                    title={{
                        label: t('pension-cocktail-fill-screen-gross-label-partner'),
                        tooltip: { title: 'TODO', text: 'TODO' },
                    }}
                    value={pensionInfo?.partner?.employeePensionGrossYearly}
                    onChange={(cents) => {
                        actions.setParameters({
                            pensionInfo: { partner: { employeePensionGrossYearly: cents } },
                        });
                    }}
                    className="mb-8"
                />
            )}

            <div className="flex flex-row flex-wrap gap-4 items-start my-8">
                <BackButton />
                <NextButton
                    nextPage={
                        isPartnerSection || !personalInfo?.isCalculatedTogether ? 'supplement' : 'pension-gross-partner'
                    }
                    isDisabled={!isValid(pensionInfo, isPartnerSection)}
                />
            </div>
            <SavingButtons/>
        </CocktailWrapperScreen>
    );
};

// const SalaryInput: React.FC<{ label: string; value?: number; onChange: (_: string) => void; className: string }> = ({
//     label,
//     value,
//     onChange,
//     className,
// }) => {
//     return (
//         <div className={`flex flex-col flex-1 ${className}`}>
//             <div className="mb-2">{label}</div>
//             <CurrencyInput
//                 allowNegativeValue={false}
//                 type="text"
//                 placeholder={'€'}
//                 className={'py-2 px-4 border border-gray-200 rounded-lg focus:outline-none'}
//                 fixedDecimalLength={0}
//                 decimalsLimit={2}
//                 intlConfig={{ currency: 'EUR', locale: 'nl-NL' }}
//                 allowDecimals={false}
//                 value={value ? value / 100 : undefined}
//                 onValueChange={(value = '', _) => onChange(value)}
//             />
//         </div>
//     );
// };

function isValid(parameters: PensionParameters['pensionInfo'], isPartnerSection: boolean): boolean {
    if (isPartnerSection) {
        return !!parameters?.partner?.employeePensionGrossYearly;
    } else {
        return !!parameters?.self?.employeePensionGrossYearly;
    }
}
